import {
  updateDepositAccountRecommendedPackagePaymentStatus,
  updateDepositAccountPaymentStatus,
} from '../../../../../shared/ServicePickerWidget/actions/depositAccount';

import { ECheckType } from './types';

export const PAYMENT_STATUS_ACTION = {
  [ECheckType.Package]: updateDepositAccountRecommendedPackagePaymentStatus,
  [ECheckType.Balance]: updateDepositAccountPaymentStatus,
};
